import {Injectable} from "@angular/core";
import {BaseService, httpOptions} from "@core/service/base.service";
import {HttpClient, HttpParams} from '@angular/common/http';
import {catchError, tap} from "rxjs/operators";
import {Observable} from "rxjs/index";
import { UploadFile } from 'ng-zorro-antd';
import {CommonsService} from "@core/service/commons.service";
import { environment } from '@env/environment';

@Injectable({providedIn: 'root'})
export class FileService extends BaseService {
// URL to web api
  public static url = 'api/file';
  // URL to web download file
  public static downloadFileUrl = FileService.url + '/download/key?_allow_anonymous=true';
  /**
   * 下载文件
   */
  downloadIO = (file: UploadFile) => {
    if (file.key) {
      this.downloadFile(file.key).subscribe((data) => {
        const blob = new Blob([data.body]);
        const blobUrl = window.URL.createObjectURL(blob);
        aOpt(blobUrl, file);
      }, (err) => {
        let blob = new Blob([err]);
        let reader: any = new FileReader();
        reader.readAsText(blob, 'utf-8');
        reader.onload = () => {
          let error = JSON.parse(reader.result);
          this.commonsService.showErrorMessage(error.message);
        };
      });
    }

    function aOpt(blobUrl, file) {
      const a = document.createElement('a');
      a.style.display = 'none';
      a.download = file.name;
      a.href = blobUrl;
      let evt = document.createEvent('MouseEvents');
      evt.initEvent('click', true, true);
      a.dispatchEvent(evt);
      a.remove();
    }
  };

  constructor(http: HttpClient, private commonsService: CommonsService) {
    super(http);
  }

  getUrl(): string {
    return FileService.url;
  }

  getDownloadFileUrl(key: string) {
    return FileService.downloadFileUrl.replace('key', key);
  }

  getDownloadFileFullUrl(key: string) {
    return environment.SERVER_URL + this.getDownloadFileUrl(key);
  }

  downloadFile(key: string): Observable<any> {
    return this.http.get(this.getDownloadFileUrl(key),
      {
        headers: httpOptions.headers,
        observe: 'response',//完整数据返回，包括抬头
        responseType: 'arraybuffer',
      },
    ).pipe(
      tap(() => this.log('query object')),
      catchError(this.handleError('get any', [])),
    );
  }
}

